export interface ApiResponse<T> {
  code: number
  msg?: string
  data: T
}

export interface PageResponse<T> {
  code: number
  msg: string
  rows: T[]
  total: number
}

export class ApiError extends Error {
  readonly code: number
  readonly status?: number
  readonly url?: string

  constructor(message: string, code: number, status?: number, url?: string) {
    super(message)
    this.name = 'ApiError'
    this.code = code
    this.status = status
    this.url = url
  }
}
